export default __webpack_public_path__ + "static/media/berlingo y amarok 3.f66ebfd6.webp";